/**
 * @generated SignedSource<<70454f07507baa69d5cea39b9eed09e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useSmartCreateFeedbackBannerFragment_content$data = Result<{
  readonly contentProperties: {
    readonly draft: {
      readonly generatedBy: string | null;
    } | null;
    readonly latest: {
      readonly generatedBy: string | null;
    } | null;
  } | null;
  readonly creatorId: string | null;
  readonly history: {
    readonly createdDate: string | null;
  } | null;
  readonly id: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly version: {
    readonly number: number | null;
  } | null;
  readonly " $fragmentType": "useSmartCreateFeedbackBannerFragment_content";
}, unknown>;
export type useSmartCreateFeedbackBannerFragment_content$key = {
  readonly " $data"?: useSmartCreateFeedbackBannerFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSmartCreateFeedbackBannerFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "generatedBy"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useSmartCreateFeedbackBannerFragment_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "creatorId"
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "number"
        }
      ]
    },
    {
      "concreteType": "History",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "createdDate"
        }
      ]
    },
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "concreteType": "DraftContentProperties",
          "kind": "LinkedField",
          "name": "draft",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "concreteType": "PublishedContentProperties",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "0a6e0a12baa6073916353e8c679c98e9";

export default node;
